"use client"
import React, { useState, useEffect } from "react";
import CommunitySubscriberForm from "@/components/communities/CommunitySubscriberForm";
import useApi from "@/components/api/useApi";
import LoadingAnimation from "@/components/shared/LoadingAnimation";
import ConfettiContainer from "@/components/shared/ConfettiContainer";

const CommunitySubscriberWidget = ({ name, onFinish }) => {
  const api = useApi();

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [
    subscriberListConfiguration,
    setSubscriberListConfiguration
  ] = useState(null);

  const [subscribed, setSubscribed] = useState(false);
  const [subscribedError, setSubscribedError] = useState(null);

  useEffect(() => {
    if (name && !loaded) {
      api
        .getCommunitySubscriberListConfiguration(name)
        .then(config => {
          // console.log("CommunitySubscriberWidget useEffect getCommunitySubscriberListConfiguration", config.data);
          setSubscriberListConfiguration(config.data);
          setLoaded(true);
        })
        .catch(error => {
          setError(error);
          setLoaded(true);
        });
    }
  }, [name]);

  const subscribe = (values, callback) => {
    // console.log("CommunitySubscriberWidget subscribe", values);
    api
      .subscribeToCommunity(name, values)
      .then(response => {
        // console.log("CommunitySubscriberWidget subscribe response", response);
        setSubscribed(true);
        callback();
        if (onFinish) {
          setTimeout(() => {
            onFinish();
          }, 5000);
        }
      })
      .catch(error => {
        // console.log("CommunitySubscriberWidget subscribe error", error);
        setSubscribedError(error);
        callback();
        if (onFinish) {
          setTimeout(() => {
            onFinish();
          }, 5000);
        }
      });
  };

  return (
    <>
      {loaded ? (
        <>
          {error ? (
            <div
              className={"center-child-div-parent"}
              style={{ margin: "2rem" }}
            >
              <p>There was an error loading this page.</p>
            </div>
          ) : (
            <>
              {subscribed || subscribedError ? (
                <div
                  className={"center-child-div-parent"}
                  style={{ margin: "2rem" }}
                >
                  {subscribed ? (
                    <ConfettiContainer>
                      <>
                        <h3>
                          {subscriberListConfiguration.completionGreeting ??
                            "Thank you for subscribing!"}
                        </h3>
                        {subscriberListConfiguration.completionText && (
                          <p>{subscriberListConfiguration.completionText}</p>
                        )}
                        {subscriberListConfiguration.subscribeSendReply && (
                          <>
                            <i
                              style={{ width: "3rem", height: "3rem" }}
                              className="fa-duotone fa-envelope-circle-check"
                            ></i>
                            <p>
                              We've sent you an email confirming your
                              subscription.
                            </p>
                          </>
                        )}
                      </>
                    </ConfettiContainer>
                  ) : (
                    <>
                      <h3>Uh oh!</h3>
                      <p>There was an error adding you to our list.</p>
                    </>
                  )}
                  {!onFinish ? (
                    <button
                      className="a"
                      onClick={() => window.location.reload()}
                    >
                      Reload this page
                    </button>
                  ) : (
                    <p>You can close this window.</p>
                  )}
                </div>
              ) : (
                <>
                  <CommunitySubscriberForm
                    configuration={subscriberListConfiguration}
                    onSubmit={(values, callback) => subscribe(values, callback)}
                  />
                </>
              )}
            </>
          )}
        </>
      ) : (
        <div className="center-child-div-parent" style={{ margin: "2rem" }}>
          <LoadingAnimation />
        </div>
      )}
    </>
  );
};
export default CommunitySubscriberWidget;
